import { render, staticRenderFns } from "./UploadClaimDocuments.vue?vue&type=template&id=4468f908&"
import script from "./UploadClaimDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadClaimDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports